import type { PostHogInitConfig } from "@wayflyer/blackbox-fe";
import type { Environment } from "shared-utils";

interface PostHogConfigOptions {
  environment: Environment;
  productionToken: string;
  developmentToken: string;
  origin: string;
  distinctID?: string;
  sessionID?: string;
}

export const createPostHogConfig = ({
  environment,
  productionToken,
  developmentToken,
  origin,
  distinctID,
  sessionID,
}: PostHogConfigOptions) =>
  ({
    token: environment === "production" ? productionToken : developmentToken,
    bootstrap: { distinctID, sessionID },
    ...(environment === "test" ? { flags_api_host: origin } : {}),
  }) satisfies PostHogInitConfig;
